module.exports = __webpack_public_path__ + "img/logo.3f04e8fa.png";